export const getPayloadParams = ({
  issue_date_start: issueDateStart,
  issue_date_end: issueDateEnd,
  tipo_movimento: tipoMovimento = "ENTRADA",
}) => ({
  order: { column: "data_emissao", type: "asc" },
  filters: [
    {
      tipo_movimento: {
        value: tipoMovimento ?? "ENTRADA",
        operatorValue: "equals",
        columnOrField: "and",
      },
    },
    {
      data_emissao: {
        start: issueDateStart,
        end: issueDateEnd,
        operatorValue: "equals",
        columnOrField: "and",
      },
    },
  ],
});
